import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";

const lesson: Lesson = {
  id: "fabd9f31-e6a2-47d9-a88c-81b1b5c403ca",
  publicId: "22",
  name: "Other types of enclosures",
  difficulty: 2,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, task01, task02],
};

export default lesson;
